import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useGetMeetingIntelligenceUserSettingsQuery, useNotetakerEntitled, UserSettingsLink, WandIcon } from 'features/meeting_intelligence';
const infoTextSectionIsPhoneCss = "i962vf1";
const infoTextSectionCss = "i1gw4dm6";
const InfoTextSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(infoTextSectionCss, {
    [infoTextSectionIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const MeetingIntelligenceDisclaimer = () => {
  const {
    isEntitled: isNotetakerEntitled
  } = useNotetakerEntitled();
  const notetakerText = I18n.t('publisher.calendar.ai_notetaker_disclaimer');
  const {
    isLoading: isMeetingIntelligenceUserLoading,
    data: meetingIntelligenceUserData
  } = useGetMeetingIntelligenceUserSettingsQuery({}, {
    skip: !isNotetakerEntitled
  });
  if (!isNotetakerEntitled || isMeetingIntelligenceUserLoading || !meetingIntelligenceUserData?.miEnabled) return null;
  return <InfoTextSection>
      <WandIcon />
      <BodyText>
        {HtmlParser(notetakerText, {
        UserSettingsLink
      })}
      </BodyText>
    </InfoTextSection>;
};

require("./meeting_intelligence_disclaimer.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_intelligence_disclaimer.js");